<template>
    <div class="mt-4">
        <b-row>
            <b-col>
                <b-form-group horizontal
                              label="Name"
                              breakpoint="lg"
                              :label-cols="2"
                              label-for="nestedStreet">
                    <b-form-input v-model="emergency_contact.name"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group horizontal
                              :label-cols="2"
                              breakpoint="lg"
                              label="Contact #:"
                              label-for="nestedCity">
                    <b-form-input v-model="emergency_contact.phone"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group horizontal
                              label="Relationship"
                              :label-cols="2"
                              breakpoint="lg"
                              label-for="nestedState">
                    <b-form-input v-model="emergency_contact.relationship"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import {cloneDeep} from 'lodash';

  export default {
    props: {
      mode: {
        type: String,
        default: 'add'
      },
      patient: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
        emergency_contact: {}
      }
    },

    created() {
      if (this.mode === 'edit') {
        const clonePatient = cloneDeep(this.patient);
        this.emergency_contact = clonePatient.emergency_contact ? clonePatient.emergency_contact : {};
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Patient/Form/ContactForm.vue